let Promise = require('bluebird');
let Vue = require('vue');

module.exports = () => new Promise((resolve, reject) => {
    Vue.component("properties_count", {
        template: `
            <div class="grid-item col-xs-12 col-sm-6 col-md-6 col-lg-3">
                <a class="dashboard-stat dashboard-stat-light widget-imoveis" v-bind:href="'/properties/search' | url">
                    <div class="visual">
                        <i class=" icon-home"></i>
                    </div>
                    <div class="details">
                        <div class="number">
                             <span class="mynumber">{{data.info.count}}</span>/{{data.info.total}}
                        </div>
                        <div class="desc">
                             Meus imóveis / Totais
                        </div>
                    </div>
                    </a>
            </div>
        `,
        props: ["alias", "data"]
    });

    resolve();
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/widgets/properties_count.js